import "../../css/pages/caseStudyV3.scss";

import SelectFilter from "../modules/selectFilter";
import LazyPagination from "../modules/lazyPagination";
import ListingSearch from "../modules/listingSearch";

import smartGrid from "../modules/smartGrid";
import customSmartGrid from "../modules/customSmartGrid";
import popUpButton from "../modules/popUpButton";
import tabsToggle from "../modules/tabsToggle";
import sectionNav from "../modules/sectionNav";
import largeCardCarousel from "../modules/largeCardCarousel";
import relatedCases from "../modules/relatedCases";

import BasePage from "./base";
import heroHomePage from "../modules/heroHomePage";
import relatedInsights from "../modules/relatedInsights";
import homepageIndustries from "../modules/homepageIndustries";
import accordion from "../modules/accordion";

class ListingPage extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
    }

    onReady() {
        super.onReady();

        sectionNav.init();
        tabsToggle.init();
        smartGrid.init();
        customSmartGrid.init();
        popUpButton.init();
        heroHomePage.init();
        relatedInsights.init();
        largeCardCarousel.init();
        homepageIndustries.init();
        window.addEventListener("load", accordion.init);
        relatedCases.init();

        new SelectFilter();

        new LazyPagination({
            context: this.context || ""
        });

        new ListingSearch();
    }
}

new ListingPage();
